class Model {
	constructor(data){
		this.data = data;
		this.trees = data.treeById;
	}

	getForestVulnerability(treeIds, treeProportions){
		return assessForest(this.data, treeIds, treeProportions);
	}

	assessForest(treeIds, treeProportions){
		return assessForest(this.data, treeIds, treeProportions);
	}

	adjustProportions(proportions,atIndex,toProportion){
		if(toProportion > 100){
			return proportions;
		}
		if(proportions.length === 0){
			return proportions;
		}
		if(proportions.length === 1){
			return [100];
		}
		proportions = proportions.slice(0);
		
		let adjustment = toProportion - proportions[atIndex];
		let balance = Math.abs(adjustment);
		let remainderUnit = adjustment > 0 ? -1 : 1;
		let i = 0;
		while(balance > 0){
			if(i === atIndex || (remainderUnit === -1 && proportions[i] === 0)){
				i = proportions.length <= ++i ? 0 : i;
				continue;
			}
			//sconsole.log(`adjusting by ${remainderUnit} @ ${i}`);
			proportions[i] += remainderUnit;
			balance--;
			i = proportions.length <= ++i ? 0 : i;
		}
		proportions[atIndex] = toProportion;

		return proportions;
	}

	getReferenceData(){
		return this.data;
	}

	balanceProportions(proportions){
		proportions = proportions.slice(0);
		proportions.fill(Math.floor(100/proportions.length));
		return balanceProportions(100, proportions.length, proportions);
	}

	getTrees(){
		return this.data.treeById;
	}
}

function balanceProportions(expectedTotal, expectedLength, ps){
	//too many items?  slice off the extra.
	ps = ps.slice(0,expectedLength);
	let total = ps.reduce((sum,p) => sum + p, 0);
	//TODO: deal with negatives
	//TODO: more graceful handling of "bust" condition
	if(total > expectedTotal){
		//when it's a bust, start afresh.
		let fairestShare = Math.floor(expectedTotal/ps.length);
		let mostlyBalancedProportions = Array(expectedLength).fill(fairestShare);
		return balanceProportions(
			expectedTotal,
			expectedLength,
			mostlyBalancedProportions);
	}
	if(ps.length < expectedLength){
		//too few items?  balance the remainder
		let missingTailLength = expectedLength-ps.length;
		let missingTail = balanceProportions(
			expectedTotal - total, 
			missingTailLength, 
			Array(missingTailLength).fill(100));
		return balanceProportions(expectedTotal, expectedLength, ps.concat(missingTail));
	}
	if(total < expectedTotal){
		//add any missing portion to the first item. that's intuitive enough.
		let remainder = expectedTotal - total;
		ps[0] = (ps[0] || 0) + remainder;
	}

	return ps;
}

function assessForest(data, treeIds, treeProportions){
	let vulnerabilitiesByTree = data["vulnerabilitiesByTreeId"];
	let allPests = data["pestById"];
	let allTrees = data["treeById"];
	let pestTypeLabelByCode = data["pestTypeLabelByCode"];
	let severityLabelByValue = data["severityLabelByValue"];
	
	//sanitize input
	//console.log('treeIds before sanitation: ', treeIds);
	treeIds = treeIds.filter(id => 0 < id && id <= allTrees.length);//.sort();
	//console.log('treeIds after sanitation: ', treeIds);
	let treeVulnerabilities = treeIds.map(id => vulnerabilitiesByTree[id-1] || {});
	//console.log(treeVulnerabilities);
	
	let pestIds = distinct(treeVulnerabilities.reduce((ids,tr) => {
		for(let id in tr){
			ids.push(id);
		}
		return ids;
	},[])).sort((a,b) => a-b);
	
	// This transpose matches the presentation of the matrix in the UI:
	let pests = pestIds.map(pId => {
		let vs = treeVulnerabilities.map((tv) => tv[pId] || 0);
		let p = allPests[pId-1];
		return {
			percentageOfPopulationAffected: vs.reduce((sum,v,i) => v > 0 ? sum + treeProportions[i] : sum, 0)/100,
			percentageOfSpeciesAffected: vs.filter(v => v > 0).length / vs.length,
			name: p.name,
			types: p.types,
			averageSeverity: vs.reduce((sum,v)=>sum+v)/vs.length,
			severityByTree: vs
		};
	}).sort((a,b) => b.percentageOfPopulationAffected - a.percentageOfPopulationAffected || b.averageSeverity - a.averageSeverity);
	
	let trees = treeIds.map(id => allTrees[id-1]).map((t,i) => {
		t.proportion = treeProportions[i];
		return t;
	});
	
	return {
		trees: trees,
		pests: pests,
		severityLabelByValue,
		pestTypeLabelByCode
	};
}

function distinct(arr){
	return Array.from(new Set(arr));
}

export default Model;